import React, { useEffect, useRef, useState } from 'react';
import Icon from '../../../components/common/Icon/Icon';
import styles from './MealOverflowMenu.module.css';

interface MealOverflowMenuProps {
  onDelete: () => void;
  deleteLabel?: string;
}

const MealOverflowMenu: React.FC<MealOverflowMenuProps> = ({
  onDelete,
  deleteLabel = 'Excluir refeição',
}) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handlePointerDown = (event: MouseEvent) => {
      if (!containerRef.current?.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handlePointerDown);
    return () => document.removeEventListener('mousedown', handlePointerDown);
  }, [open]);

  return (
    <div className={styles.container} ref={containerRef}>
      <button
        type="button"
        className={styles.trigger}
        aria-label="Mais opções"
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
      >
        <Icon name="more_vert" size={20} color="var(--color-text-muted)" />
      </button>

      {open && (
        <div className={styles.menu} role="menu">
          <button
            type="button"
            className={styles.menuItemDanger}
            role="menuitem"
            onClick={() => {
              setOpen(false);
              onDelete();
            }}
          >
            {deleteLabel}
          </button>
        </div>
      )}
    </div>
  );
};

export default MealOverflowMenu;
